// Pure module: no imports. Must stay runnable with Node's built-in type stripping.

export type WalletGateDecision = "reviewer-readonly" | "create-wallet" | "connect-wallet" | "mismatch" | "ok"
export type ConnectWalletDecision = "dashboard" | "create-wallet" | "stay"

export function decodeJwtPayload(token: unknown): Record<string, unknown> | null {
  try {
    if (typeof token !== "string") return null
    const parts = token.split(".")
    if (parts.length !== 3 || !parts[1]) return null
    let b64 = parts[1].replace(/-/g, "+").replace(/_/g, "/")
    while (b64.length % 4 !== 0) b64 += "="
    const binary = globalThis.atob(b64)
    const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0))
    const parsed: unknown = JSON.parse(new TextDecoder().decode(bytes))
    if (parsed === null || typeof parsed !== "object" || Array.isArray(parsed)) return null
    return parsed as Record<string, unknown>
  } catch {
    return null
  }
}

export function isReviewerToken(token: unknown): boolean {
  return decodeJwtPayload(token)?.reviewer === true
}

export function canPerformTraceActions(isReviewer: boolean): boolean {
  return !isReviewer
}

export function walletGateDecision(input: {
  isReviewer: boolean
  wallet?: string | null
  isConnected?: boolean
  account?: string | null
}): WalletGateDecision {
  if (input.isReviewer) return "reviewer-readonly"
  if (!input.wallet) return "create-wallet"
  if (!input.isConnected) return "connect-wallet"
  if (input.account?.toLowerCase() !== input.wallet.toLowerCase()) return "mismatch"
  return "ok"
}

export function connectWalletDecision(input: {
  isReviewer: boolean
  wallet?: string | null
  isConnected?: boolean
}): ConnectWalletDecision {
  if (input.isReviewer) return "dashboard"
  if (!input.wallet) return "create-wallet"
  if (input.isConnected) return "dashboard"
  return "stay"
}
